import { Checkbox } from '@/components/ui/checkbox'
import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from '@/components/ui/form'
import { Input } from '@/components/ui/input'
import type { DeleteCompanyFormValues } from '@/routes/billing/danger-zone/delete-company-sheet/reasons'
import type { UseFormReturn } from 'react-hook-form'

type Props = {
  form: UseFormReturn<DeleteCompanyFormValues>
  companyName: string
  isOnlyCompany: boolean
}

export const ConfirmStep = ({ form, companyName, isOnlyCompany }: Props) => {
  return (
    <>
      <div className="rounded-lg border border-destructive/30 bg-destructive/5 p-4 text-sm">
        <p className="font-medium mb-2">
          What happens when you delete this company
        </p>
        <ul className="list-disc pl-4 space-y-1 text-muted-foreground">
          <li>
            Your Sevalla subscription is cancelled and your final balance is
            settled immediately. Final invoices over $1 are charged; smaller
            balances are forgiven.
          </li>
          <li>This company and its data are deleted right away.</li>
          <li>Deletion is immediate and cannot be undone.</li>
          <li>
            If this company is shared with MyKinsta, only the Sevalla
            subscription ends and your MyKinsta account is kept.
          </li>
        </ul>
      </div>
      {isOnlyCompany ? (
        <FormField
          control={form.control}
          name="deleteAccount"
          render={({ field: { value, onChange, ...field } }) => (
            <FormItem className="flex gap-2">
              <FormControl>
                <Checkbox
                  id="deleteAccount"
                  checked={value}
                  onCheckedChange={onChange}
                  {...field}
                />
              </FormControl>
              <FormLabel
                htmlFor="deleteAccount"
                className="cursor-pointer flex flex-col items-start justify-center"
              >
                Also delete my user account
              </FormLabel>
            </FormItem>
          )}
        />
      ) : null}
      <FormField
        control={form.control}
        name="confirmName"
        render={({ field }) => (
          <FormItem>
            <FormLabel>
              Type <span className="font-semibold">{companyName}</span> to
              confirm
            </FormLabel>
            <FormControl>
              <Input
                autoComplete="off"
                aria-label="Confirm company name"
                {...field}
              />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
    </>
  )
}
